import { Trophy, Swords, Zap, Dribbble, Gamepad2, Brain, ArrowUpRight } from "lucide-react";
import { ENAGA_PHOTOS } from "@/lib/localMedia";

// TODO (equipe): substituir as imagens 'cover' abaixo por fotos oficiais de
// cada modalidade assim que forem enviadas ao Instituto.
const PROJETOS = [
  {
    id: "futebol",
    titulo: "GA Futebol Clube",
    desc: "Escola de base e equipes competitivas: a primeira porta de entrada do Instituto.",
    icon: Trophy,
    cor: "#10B981",
    cover: "/uploads/ga/ga-basquete.jpg",
  },
  {
    id: "jiujitsu",
    titulo: "Jiu-jitsu",
    desc: "Disciplina, respeito e defesa pessoal: técnica que forma caráter.",
    icon: Swords,
    cor: "#0F172A",
    cover: "/uploads/ga/ga-jiujitsu.jpg",
  },
  {
    id: "taekwondo",
    titulo: "Taekwondo",
    desc: "Foco, superação e autocontrole pela arte marcial olímpica.",
    icon: Zap,
    cor: "#F59E0B",
    cover: ENAGA_PHOTOS.desenvolvimento,
  },
  {
    id: "basquete",
    titulo: "Basquete",
    desc: "Time coletivo e aulas para todas as idades, do aprendizado à competição.",
    icon: Dribbble,
    cor: "#3B82F6",
    cover: "/uploads/ga/ga-basquete.jpg",
  },
  {
    id: "esports",
    titulo: "E-sports",
    desc: "Jogos eletrônicos como espaço seguro, formação digital e desenvolvimento social.",
    icon: Gamepad2,
    cor: "#8B5CF6",
    cover: ENAGA_PHOTOS.atendimento,
  },
  {
    id: "enaga",
    titulo: "ENAGA",
    desc: "Centro terapêutico para neurodiversidade: atendimento multidisciplinar.",
    icon: Brain,
    cor: "#EF4444",
    cover: ENAGA_PHOTOS.autismo,
  },
];

export default function NossosProjetos() {
  return (
    <section
      id="nossos-projetos"
      data-testid="nossos-projetos-section"
      className="section-pad bg-background"
    >
      <div className="container-ga">
        <div className="max-w-2xl mb-10">
          <div className="pill border-ga-amber/30 text-ga-amber_deep bg-ga-amber/10 mb-5" data-testid="projetos-pill">
            Nossos projetos
          </div>
          <h2 className="font-display font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-ga-ink">
            Seis caminhos para <span className="gradient-text-ga">formar gente</span>.
          </h2>
          <p className="mt-4 text-ga-ink/60 text-base sm:text-lg">
            Esporte, saúde e neurodiversidade: cada projeto com sua
            identidade, todos com a mesma missão.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="projetos-grid">
          {PROJETOS.map((p) => (
            <article
              key={p.id}
              data-testid={`projeto-${p.id}`}
              className="group relative rounded-3xl overflow-hidden bg-ga-ink aspect-[4/5] hover-lift"
            >
              <img
                src={p.cover}
                alt={p.titulo}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ga-ink via-ga-ink/55 to-ga-ink/5" />

              <div className="relative h-full flex flex-col p-6">
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center text-white shadow-lg"
                  style={{ background: p.cor }}
                >
                  <p.icon className="w-5 h-5" />
                </div>

                <div className="mt-auto text-white">
                  <h3 className="font-display font-bold text-2xl">{p.titulo}</h3>
                  <p className="mt-2 text-sm text-white/80 leading-relaxed">{p.desc}</p>
                  <div className="mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] opacity-70 group-hover:opacity-100 transition-opacity">
                    Conhecer <ArrowUpRight className="w-3 h-3" />
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
